export default (params) => ({
  trigger: {
    name: 'order_block_summary.click_reviews_in_order_block_summary',
    params: params,
  },
  config: {
    schema: {
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'read_reviews',
      params: {
        sub_feature: null,
      },
    },
  },
});
